import {lazy} from 'react';

export const FileInfoLazy = lazy(() => import(/* webpackChunkName: "fileListInfo" */ '.'));
